import { ColumnDef } from "@tanstack/react-table";
import { formatDate, formatTime } from "../../helperFunctions";
import { auditLogFields } from "../../types/auditLog";
import { loginLogFields } from "../../types/loginLog";
import { AuditActionsLabels, AuditActionType, TableNameLabels } from "../../constants";

// Helper συνάρτηση για ασφαλή ανάγνωση τιμής ανεξαρτήτως πεζών/κεφαλαίων
const getNestedValue = (row: any, key: string) => {
  if (!row) return undefined;
  const lowerKey = key.toLowerCase();
  const camelKey = key.charAt(0).toLowerCase() + key.slice(1);
  const pascalKey = key.charAt(0).toUpperCase() + key.slice(1);

  return row[key] ?? row[camelKey] ?? row[pascalKey] ?? row[lowerKey];
};

// Στήλες για τα Login Logs
export const loginLogColumns: ColumnDef<any>[] = loginLogFields.map((field) => ({
  accessorKey: field.name as string,
  header: field.label,
  cell: ({ row }) => {
    const originalData = row.original;
    const key = String(field.name);
    const val = getNestedValue(originalData, key);

    if (key.toLowerCase().includes("date") || key.toLowerCase().includes("timestamp")) {
      return val ? formatDate(String(val)) : "";
    }
    if (key.toLowerCase().includes("time")) {
      return val ? formatTime(String(val)) : "";
    }
    if (typeof val === "boolean") {
      return val ? "Ναι" : "Όχι";
    }

    return val !== undefined && val !== null ? String(val) : "";
  },
}));

// Στήλες για τα Audit Logs
export const auditLogColumns: ColumnDef<any>[] = auditLogFields.map((field) => ({
  accessorKey: field.name as string,
  header: field.label,
  cell: ({ row }) => {
    const originalData = row.original;
    const key = String(field.name);
    const val = getNestedValue(originalData, key);

    if (key.toLowerCase().includes("date") || key.toLowerCase().includes("timestamp")) {
      return val ? formatDate(String(val)) : "";
    }
    if (key.toLowerCase().includes("time")) {
      return val ? formatTime(String(val)) : "";
    }
    
    if (key === "Action") {
      return val !== undefined && val !== null ? AuditActionsLabels[val as AuditActionType] || String(val) : "";
    }
    if (key === "TableName") {
      return val !== undefined && val !== null ? TableNameLabels[String(val)] || String(val) : "";
    }

    return val !== undefined && val !== null ? String(val) : "";
  },
}));